module.exports = new __parcel__URL__("access-medicine.132c5f3c.png").toString();